import { useState } from 'preact/hooks'
import { startSignProcess } from '@/services/api'
import { getProcessId, saveQrCodeData } from '@/services/session'
import type { StartSignProcessRequest } from '@cencert/mob-signature'

interface UseStartSignProcessOptions {
  email?: string | undefined
  noPesel: boolean
  marketingConsents?: string[] | undefined
}

interface UseStartSignProcessReturn {
  startSign: (options: UseStartSignProcessOptions) => Promise<void>
  isStarting: boolean
  error: string | null
}

export function useStartSignProcess(): UseStartSignProcessReturn {
  const [isStarting, setIsStarting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const startSign = async (options: UseStartSignProcessOptions) => {
    const processId = getProcessId()
    if (!processId) {
      setError('Brak ID procesu')
      throw new Error('No process ID available')
    }

    setIsStarting(true)
    setError(null)

    try {
      const request: StartSignProcessRequest = {
        processId,
        genQrCode: true,
        noPesel: options.noPesel,
        ...(options.email && { email: options.email }),
        ...(options.marketingConsents &&
          options.marketingConsents.length > 0 && {
            marketingConsentsCodes: options.marketingConsents,
          }),
      }

      const response = await startSignProcess(request)

      if (response) {
        saveQrCodeData(response)
      }
    } catch (err) {
      const errorMessage =
        err instanceof Error
          ? err.message
          : 'Błąd rozpoczynania procesu podpisu'
      setError(errorMessage)
      throw err
    } finally {
      setIsStarting(false)
    }
  }

  return {
    startSign,
    isStarting,
    error,
  }
}
